import { Controller } from "@hotwired/stimulus";
import { useClickOutside } from "stimulus-use";

export default class extends Controller {
  static targets = ["sidebar"];

  connect() {
    useClickOutside(this);
  }

  toggle() {
    this.sidebarTarget.classList.toggle("-translate-x-full");
    console.log("math");
  }

  close(event) {
    event.preventDefault();
    this.sidebarTarget.classList.add("-translate-x-full");
  }
}
